import React, { useState, useEffect } from "react";
import topscroll from './Images/toptoscroll.png';

function ScrollToTopButton() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return visible ? (
    <button
      onClick={scrollToTop}
      style={{
        position: "fixed",
        right: "24px",
        bottom: "40px",
        background: "#fffdfeff",
        color: "#f50909ff",
        border: "none",
        borderRadius: "50%",
        width: "55px",
        height: "55px",
        fontSize: "2rem",
        boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
        cursor: "pointer",
        zIndex: 1000,
        transform: "rotate(-73deg)"

      }}
      aria-label="Scroll to top"
    >
    <img src={topscroll} alt="up-arrow" style={{width:'46px', height:'46px', margin:"4px -19px"}} /> 
    </button>
  ) : null;
}

export default ScrollToTopButton;